module.exports = __webpack_public_path__ + "img/Bean-5.af9b32f4.svg";